let googleAdsInitialized = false;

export function initGoogleAds(): void {
  if (googleAdsInitialized) return;

  const { hostname } = window.location;
  const isProd = hostname === 'webapp.everydoggy.com' || hostname === 'app.everydoggy.com';

  if (!isProd) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-16857709798';
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function gtag(...args: any[]): void {
    window.dataLayer.push(args);
  }

  window.gtag = window.gtag || gtag;

  window.gtag('js', new Date());
  window.gtag('config', 'AW-16857709798', {
    send_page_view: true,
  });

  googleAdsInitialized = true;
}
